import React from 'react';

const LegalLayout = ({ title, children }) => {
  return (
    <div className="container mx-auto px-4 py-16 max-w-3xl">
      <h1 className="text-3xl md:text-4xl font-bold mb-8 text-textMain">{title}</h1>
      <div className="prose prose-invert prose-blue max-w-none">
        {/* We emulate prose styles manually to keep it independent of extra plugins, 
            but structured for standard HTML elements passed as children */}
        <div className="space-y-6 text-textMuted leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
};

export default LegalLayout;